/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_CostsInputs */

const cs_billing_costs = /** @type {(inputs: Billing_CostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceny funkcí`)
};

const en_billing_costs = /** @type {(inputs: Billing_CostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature costs`)
};

/**
* | output |
* | --- |
* | "Feature costs" |
*
* @param {Billing_CostsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_costs = /** @type {((inputs?: Billing_CostsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_CostsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_costs(inputs)
	return cs_billing_costs(inputs)
});